import React from 'react';
import { Shield, ShieldOff } from 'lucide-react';
import type { DeviceStatus, AEStatus } from '../types/dicom';
import { Badge } from '../custom-components/custom-components';

export const getDeviceStatusBadge = (status: DeviceStatus) => {
  const statusConfig = {
    active: { className: 'bg-green-100 text-green-800', text: 'Active' },
    inactive: { className: 'bg-gray-100 text-gray-800', text: 'Inactive' },
    starting: { className: 'bg-yellow-100 text-yellow-800', text: 'Starting' },
    stopping: { className: 'bg-orange-100 text-orange-800', text: 'Stopping' },
    error: { className: 'bg-red-100 text-red-800', text: 'Error' },
  };
  const config = statusConfig[status];
  return <Badge className={config.className}>{config.text}</Badge>;
};



export const getAEStatusBadge = (status: AEStatus) => {
  const statusConfig = {
    running: { className: 'bg-green-100 text-green-800', text: 'Running' },
    stopped: { className: 'bg-gray-100 text-gray-800', text: 'Stopped' },
    starting: { className: 'bg-yellow-100 text-yellow-800', text: 'Starting' },
    error: { className: 'bg-red-100 text-red-800', text: 'Error' },
  };
  const config = statusConfig[status];
  return <Badge className={config.className}>{config.text}</Badge>;
};

export const getSecureBadge = (secure: boolean) => {
  return secure ? (
    <Badge className="bg-blue-100 text-blue-800 flex items-center gap-1">
      <Shield className="h-3 w-3" />
      TLS Enabled
    </Badge>
  ) : (
    <Badge className="bg-gray-100 text-gray-600 flex items-center gap-1">
      <ShieldOff className="h-3 w-3" />
      No TLS
    </Badge>
  );
};
